<template>

<div class="inputs">
	
	<slot></slot>
	
</div>

</template>

<script>

export default {

}

</script>

<style scoped>

.inputs {
    background-color: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
    margin: 10px;
}

.inputs >>> .group {
    border-bottom: 1px solid #2b5870;
}

.is-mobile .inputs >>> .group {
    background-color: #4B7185;
}

.is-mobile .inputs >>> .group:first-child {
    border-radius: 10px 10px 0px 0px;
}

.is-mobile .inputs >>> .group:last-child {
    border-radius: 0px 0px 10px 10px;
}

.inputs >>> .input:last-child,
.inputs >>> .group:last-child {
    border-bottom: 0px;
}

.inputs >>> .input.is-inline, 
.inputs >>> .input.is-inset {
    margin: 0px;
}

.inputs >>> .input.is-inline input, 
.inputs >>> .input.is-inset input {
    background-color: transparent!important;
    padding: 0px;
    margin: 0px;
    font-size: 14px;
    height: 20px;
}

.is-mobile .inputs >>> .input.is-inline,
.is-mobile .inputs >>> .input.is-inset {
    padding: 0px;
}

.is-mobile .inputs >>> .input.is-inline input, 
.is-mobile .inputs >>> .input.is-inset input {
    border: 1px solid #eee;
    border-radius: 10px;
    padding: 0px 10px;
    height: 40px;
    color: #343434;
}

.inputs >>> .input.is-inline input::placeholder, 
.inputs >>> .input.is-inset input::placeholder {
    color: #8098a5;
}

.is-mobile .inputs >>> .input.is-inline input::placeholder, 
.is-mobile .inputs >>> .input.is-inset input::placeholder {
    color: #ccc;
}

</style>
